/* eslint-disable prettier/prettier */
import BrandOwli from './brand-owli.svg'
import CentralizeIcon from './centralize-icon.svg'
import ChartLine from './chart-line.svg'
import CircleWaves from './circle-waves.svg'
import CondoCta from './condo-cta.svg'
import CondoDifferential from './condo-differential.svg'
import CondoFeature1 from './condo-feature-1.svg'
import CondoFeature2 from './condo-feature-2.svg'
import CondoFeature3 from './condo-feature-3.svg'
import CondoHero from './condo-hero.svg'
import CondoInfobanner from './condo-infobanner.svg'
import CreditCard from './credit-card.svg'
import DiminuaIcon from './diminua-icon.svg'
import Dollar from './dollar.svg'
import FacilityMain1 from './facility-main-1.svg'
import FacilityMain from './facility-main.svg'
import Facility from './facility.svg'
import Flexibility1 from './flexibility-1.svg'
import Flexibility2 from './flexibility-2.svg'
import FlexibilityMain from './flexibility-main.svg'
import Flexibility from './flexibility.svg'
import Flexibilitymain from './flexibilitymain.svg'
import HeroImob2 from './hero-imob-2.svg'
import HeroImob3 from './hero-imob-3.svg'
import HeroImob from './hero-imob.svg'
import IconMobility from './icon-mobility.svg'
import IllustFeature1 from './illust-feature-1.svg'
import IllustrFacility1 from './illustr-facility-1.svg'
import IllustrFacility from './illustr-facility.svg'
import Integration from './integration.svg'
import LogoRedeVistorias from './logo-rede-vistorias.svg'
import Mobility1 from './mobility-1.svg'
import Mobility from './mobility.svg'
import OferecaIcon from './ofereca-icon.svg'
import OtimizeIcon from './otimize-icon.svg'
import RedeVistoriasLogo from './rede-vistorias-logo.svg'

export default {
  'brand-owli': BrandOwli,
  'centralize-icon': CentralizeIcon,
  'chart-line': ChartLine,
  'circle-waves': CircleWaves,
  'condo-cta': CondoCta,
  'condo-differential': CondoDifferential,
  'condo-feature-1': CondoFeature1,
  'condo-feature-2': CondoFeature2,
  'condo-feature-3': CondoFeature3,
  'condo-hero': CondoHero,
  'condo-infobanner': CondoInfobanner,
  'credit-card': CreditCard,
  'diminua-icon': DiminuaIcon,
  'dollar': Dollar,
  'facility-main-1': FacilityMain1,
  'facility-main': FacilityMain,
  'facility': Facility,
  'flexibility-1': Flexibility1,
  'flexibility-2': Flexibility2,
  'flexibility-main': FlexibilityMain,
  'flexibility': Flexibility,
  'flexibilitymain': Flexibilitymain,
  'hero-imob-2': HeroImob2,
  'hero-imob-3': HeroImob3,
  'hero-imob': HeroImob,
  'icon-mobility': IconMobility,
  'illust-feature-1': IllustFeature1,
  'illustr-facility-1': IllustrFacility1,
  'illustr-facility': IllustrFacility,
  'integration': Integration,
  'logo-rede-vistorias': LogoRedeVistorias,
  'mobility-1': Mobility1,
  'mobility': Mobility,
  'ofereca-icon': OferecaIcon,
  'otimize-icon': OtimizeIcon,
  'rede-vistorias-logo': RedeVistoriasLogo,
}